/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThickMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABfElEQVR4nOWUv0oDQRDGU9mIWIkEQRtre4PYBTS5+XPC3kwSEUF8CZuIjfEhtDe+hSIKgoVgE8HO2GqtEllyhzFebjdyheDANHe732/mm90tFP59GGMmkOUISLrA8oSsLfstN2OQtYWsvaFs5QYAku4PAOmztwBRrYIkpzYDlvVv1SNOpVTfs1Z5iSNrM0Wg+QWIVlMBpIc+4gdpm/sV6gmy7iLrw3DlXkMGkv1R4vjDb+kQSalc3pz0siURB5IPHwCQ7HgJD3n+BqyRTydAcuwnjtFWPKB3DCMd066mG0DSiSvaHmUbZmWo1UwAkL7YhWHYKKb/l2wIadvRgbbjo3ZtjJkeG0IOgK0cWR8TCIBZBJYbJL1yQfpzc1hko7JRX0gg9iTFsNs1Y2YGYQHXlqtVM+cU9IEQSQlY7hLYr0T9OtF7AJ1N1gDrpcctv/CGAOhSwLWV5J2xm52XkPU8s5MgMPMDkOTm7hXyjDBsFIHlDFle44etnivgz8cn2ECO8EfnvNEAAAAASUVORK5CYII=)
 */
export const PaintbrushThickMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.35 7.24C15.9 6.67 16 5.8 16 5a3 3 0 1 1 3 3c-.8 0-1.67.09-2.24.65a1.5 1.5 0 0 0 0 2.11l1.12 1.12a3 3 0 0 1 .26 3.95.46.46 0 0 1-.37.17H15a3 3 0 0 0-1.21.26.56.56 0 0 1-.63-.1L6.91 9.91 4.3 12.54a1 1 0 0 0 0 1.42l2.17 2.17.83-.84a1 1 0 0 1 1.42 1.42l-.84.83.59.59 1.83-1.84a1 1 0 0 1 1.42 1.42l-1.84 1.83.17.17a1 1 0 0 0 1.42 0c.2-.2.6-.07.69.22a3 3 0 0 0 .56 1c.09.11.09.27-.02.36a3 3 0 0 1-4.06-.16l-5.76-5.76a3 3 0 0 1 0-4.24L6.9 7.09h.01l.97-.97a3 3 0 0 1 4.24 0l1.12 1.12a1.5 1.5 0 0 0 2.1 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
